/* BeyTik - dock behaviour: sheets, accordion menu, live search, cart count, scroll progress.
 *
 * - Categories / Search open <dialog> sheets (bottom sheet on phones, side drawer
 *   on desktop). The header hamburger opens the SAME menu sheet on every screen
 *   size, so there is one menu. That listener is on the document in the CAPTURE
 *   phase so it runs before the theme's own drawer script and can stop it.
 * - The menu is an accordion: tap a row, its options expand in place; one row
 *   open at a time. Closed panels are marked inert so their links leave the tab
 *   order (CSS collapses them with a 0fr grid row, which keeps them focusable).
 * - Cart opens the cart drawer through the (hidden) header cart icon, whose own
 *   click handler the theme already wired; with no drawer it just follows the link.
 * - The cart count refreshes after any /cart/add|change|update|clear request, by
 *   wrapping window.fetch (kept from the old bar; the product forms use fetch).
 * - A one-time "tap to browse categories" bubble shows 3s after load, once per
 *   browser session.
 */
(function () {
  'use strict';
  if (window.__btDock) return;
  window.__btDock = true;

  var root = document.querySelector('.btm-root');
  if (!root) return;

  var html = document.documentElement;
  var mobile = window.matchMedia('(max-width: 1024px)');
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  function sget(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function sset(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  /* ---------- sheets ---------- */
  var catsDlg = document.getElementById('btm-cats');
  var searchDlg = document.getElementById('btm-search');

  function openSheet(d) {
    if (!d || d.open) return;
    hideHint();
    html.classList.add('btm-open');
    d.showModal();
    if (d === searchDlg) { var q = $('input[name="q"]', d); if (q) setTimeout(function () { q.focus(); }, 160); }
  }
  [catsDlg, searchDlg].forEach(function (d) {
    if (!d) return;
    d.addEventListener('click', function (e) { if (e.target === d) d.close(); });
    d.addEventListener('close', function () { html.classList.remove('btm-open'); });
    var x = $('[data-close]', d);
    if (x) x.addEventListener('click', function () { d.close(); });
  });

  $$('[data-dock="cats"]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openSheet(catsDlg); });
  });
  $$('[data-dock="search"]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openSheet(searchDlg); });
  });
  $$('[data-dock="cart"]').forEach(function (b) {
    b.addEventListener('click', function (e) {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && document.querySelector('cart-drawer')) { e.preventDefault(); bubble.click(); }
    });
  });

  /* header hamburger -> the same menu sheet, any screen size */
  document.addEventListener('click', function (e) {
    if (!catsDlg || !e.target.closest('header-drawer summary')) return;
    e.preventDefault();
    e.stopPropagation();
    openSheet(catsDlg);
  }, true);

  /* ---------- which page am I on ---------- */
  var path = location.pathname.replace(/\/$/, '') || '/';
  $$('a.btm-i').forEach(function (a) {
    var h = (a.getAttribute('href') || '').split('?')[0].replace(/\/$/, '') || '/';
    if (h === path) a.classList.add('is-here');
  });

  /* ---------- accordion ---------- */
  var accs = $$('.btm-acc', catsDlg || root);
  function setOpen(acc, open) {
    acc.classList.toggle('is-open', open);
    acc.querySelector('.btm-acc__hd').setAttribute('aria-expanded', String(open));
    var p = acc.querySelector('.btm-acc__panel');
    if (open) p.removeAttribute('inert'); else p.setAttribute('inert', '');
  }
  accs.forEach(function (acc) {
    setOpen(acc, false);
    acc.querySelector('.btm-acc__hd').addEventListener('click', function () {
      var willOpen = !acc.classList.contains('is-open');
      accs.forEach(function (o) { setOpen(o, o === acc && willOpen); });
      if (willOpen) setTimeout(function () { acc.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }, 90);
    });
  });
  if (catsDlg) catsDlg.addEventListener('close', function () { accs.forEach(function (a) { setOpen(a, false); }); });

  /* ---------- cart count ---------- */
  var badge = $('[data-btm-count]');
  function paint(n) { if (!badge) return; badge.textContent = n > 99 ? '99+' : String(n); badge.hidden = !n; }
  function readCart() {
    if (!badge) return;
    var base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(base + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) paint(c.item_count || 0); })
      .catch(function () {});
  }
  readCart();
  window.addEventListener('pageshow', readCart);
  if (window.fetch && !window.__btFetchWrapped) {
    window.__btFetchWrapped = true;
    var orig = window.fetch;
    window.fetch = function () {
      var p = orig.apply(this, arguments);
      try {
        var u = String(arguments[0] && arguments[0].url ? arguments[0].url : arguments[0] || '');
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(readCart, 120); });
      } catch (e) {}
      return p;
    };
  }
  document.addEventListener('cart:refresh', readCart);
  document.addEventListener('cart:updated', readCart);
  if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS) subscribe(PUB_SUB_EVENTS.cartUpdate, readCart);

  /* ---------- scroll progress ---------- */
  var prog = document.querySelector('.bt-prog__i');
  if (prog) {
    var lastT = 0, tt = null;
    var upd = function () {
      var y = window.pageYOffset || html.scrollTop || 0;
      var max = html.scrollHeight - (window.innerHeight || 0);
      prog.style.setProperty('--p', max > 0 ? Math.min(Math.max(y / max, 0), 1) : 0);
    };
    window.addEventListener('scroll', function () {
      var now = Date.now();
      if (now - lastT >= 50) { lastT = now; upd(); return; }
      clearTimeout(tt); tt = setTimeout(function () { lastT = Date.now(); upd(); }, 60);
    }, { passive: true });
    upd();
  }

  /* ---------- "tap to browse categories" bubble ---------- */
  var hint = $('.btm-hint');
  var hero = $('.btm-i--hero');
  var hintTimer = null;
  function hideHint() {
    if (!hint || hint.hidden) return;
    clearTimeout(hintTimer);
    hint.classList.remove('is-in');
    if (hero) hero.classList.remove('is-pulse');
    setTimeout(function () { hint.hidden = true; }, 300);
  }
  if (hint && hero) {
    hint.addEventListener('click', function () { hideHint(); openSheet(catsDlg); });
    $$('.btm-i').forEach(function (b) { b.addEventListener('pointerdown', hideHint); });
    if (mobile.matches && !sget('btDockHint')) {
      setTimeout(function () {
        if (html.classList.contains('btm-open')) return;
        hint.hidden = false;
        requestAnimationFrame(function () { hint.classList.add('is-in'); hero.classList.add('is-pulse'); });
        sset('btDockHint', '1');
        hintTimer = setTimeout(hideHint, 7000);
      }, 3000);
    }
  }

  /* ---------- live search ---------- */
  var form = searchDlg && $('form', searchDlg);
  if (!form) return;
  var input = form.elements.q;
  var res = $('[data-res]', searchDlg);
  var idle = $('[data-idle]', searchDlg);
  var SUGGEST = (root.getAttribute('data-suggest') || '/search/suggest') + '.json';
  var SEARCH = root.getAttribute('data-search') || '/search';
  var sample = root.getAttribute('data-money') || '';
  var mm = sample.match(/^(\D*)[\d.,\s]+(\D*)$/);
  var PRE = mm ? mm[1] : '', POST = mm ? mm[2] : '';
  /* the regex above swallows the space before a currency code ("$9 USD"), so put it back */
  if (/^[A-Za-z]/.test(POST)) POST = ' ' + POST;
  function money(v) {
    var n = parseFloat(v);
    if (!isFinite(n) || n <= 0) return '';
    return PRE + n.toFixed(2).replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',') + POST;
  }
  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  var timer = null, ctrl = null, lastQ = '';
  function render(q, data) {
    var items = (data && data.resources && data.resources.results && data.resources.results.products) || [];
    if (!items.length) { res.innerHTML = '<p class="btm-msg">Nothing matched “' + esc(q) + '”. Try a model or a brand.</p>'; return; }
    var h = '';
    items.slice(0, 8).forEach(function (p) {
      var img = p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      h += '<a class="btm-r" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" width="54" height="54" loading="lazy">' : '<i></i>') +
        '<span><b>' + esc(p.title) + '</b><em>' + money(p.price) + '</em></span></a>';
    });
    h += '<a class="btm-all" href="' + SEARCH + '?q=' + encodeURIComponent(q) + '&type=product">See all results</a>';
    res.innerHTML = h;
  }
  function run(q) {
    if (ctrl) ctrl.abort();
    ctrl = ('AbortController' in window) ? new AbortController() : null;
    fetch(SUGGEST + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', { signal: ctrl ? ctrl.signal : undefined })
      .then(function (r) { return r.json(); })
      .then(function (d) { if (q === lastQ) render(q, d); })
      .catch(function (e) { if (e && e.name !== 'AbortError') res.innerHTML = ''; });
  }
  input.addEventListener('input', function () {
    var q = input.value.trim();
    lastQ = q;
    clearTimeout(timer);
    if (q.length < 2) { res.hidden = true; res.innerHTML = ''; idle.hidden = false; return; }
    idle.hidden = true; res.hidden = false;
    timer = setTimeout(function () { run(q); }, 200);
  });
  form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
})();